import React from 'react';
import { inject, observer } from 'mobx-react';
import Tabstyle_1 from './1/Tabstyle_1'
import Tabstyle_2 from './2/TabStyle_2'
import Tabstyle_3 from './3/Tabstyle_3'
import Tabstyle_4 from './4/TabStyle_4'
import Tabstyle_10 from './10/Tabstyle_10'
import Tabstyle_11 from './11/Tabstyle_11'
import Tabstyle_12 from './12/Tabstyle_12'
import Tabstyle_13 from './13/Tabstyle_13'
import Tabstyle_14 from './14/Tabstyle_14'
import Tabstyle_15 from './15/Tabstyle_15'
import Tabstyle_16 from './16/Tabstyle_16'
import Tabstyle_30 from './30/Tabstyle_30'
import Tabstyle_31 from './31/Tabstyle_31'
import Tabstyle_32 from './32/Tabstyle_32'
import Tabstyle_33 from './33/Tabstyle_33'
import Tabstyle_34 from './34/Tabstyle_34'
import Tabstyle_35 from './35/Tabstyle_35'
import Tabstyle_36 from './36/Tabstyle_36'
import Tabstyle_37 from './37/Tabstyle_37'
import Tabstyle_38 from './38/Tabstyle_38'
import Tabstyle_39 from './39/Tabstyle_39'
//元素组件
export default class  Tabstyle extends React.Component {
    constructor(props) {
        super(props);   
    }

    render() {
        const { tabvalue , tabid } = this.props;
        let tabtitle=<div></div>;
        switch (tabvalue) {
            //箭头图标
            case '1':tabtitle=<Tabstyle_1 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_1@osp2ko`} {...this.props} tabid={tabid}/>;break;
            //彩色箭头
            case '2':tabtitle=<Tabstyle_2 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_2@iyklal`} {...this.props} tabid={tabid}/>;break;
            //蓝灰箭头
            case '3':tabtitle=<Tabstyle_3 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_3@l6lxdr`} {...this.props} tabid={tabid}/>;break;
            //多彩叠层
            case '4':tabtitle=<Tabstyle_4 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_4@lst18m`} {...this.props} tabid={tabid}/>;break;
            //气泡TAB
            case '10':tabtitle=<Tabstyle_10 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_10@j1hn3m`}  {...this.props} tabid={tabid}/>;break;
            //气泡图标TAB
            case '11':tabtitle=<Tabstyle_11 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_11@gprycf`}  {...this.props} tabid={tabid}/>;break;
            // 彩条图标
            case '12':tabtitle=<Tabstyle_12 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_12@twcvy9`}  {...this.props} tabid={tabid}/>;break;
            // 便利贴1
            case '13':tabtitle=<Tabstyle_13 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_13@5s040w`}  {...this.props} tabid={tabid}/>;break;
            // 便利贴2
            case '14':tabtitle=<Tabstyle_14 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_14@wru9vf`}  {...this.props} tabid={tabid}/>;break;
            // 便利贴3
            case '15':tabtitle=<Tabstyle_15 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_15@6ndqzy`}  {...this.props} tabid={tabid}/>;break;
            // 便利贴4
            case '16':tabtitle=<Tabstyle_16 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_16@bz3g7h`}  {...this.props} tabid={tabid}/>;break;
            // 点选图标样式
            case '30':tabtitle=<Tabstyle_30 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_30@iqb5mu`}  {...this.props} tabid={tabid}/>;break;
            // 标准图标样式
            case '31':tabtitle=<Tabstyle_31 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_31@gwpnbs`}  {...this.props} tabid={tabid}/>;break;
            // 滑动tab1
            case '32':tabtitle=<Tabstyle_32 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_32@t4ykv5`}  {...this.props} tabid={tabid}/>;break;
            // 滑动tab2
            case '33':tabtitle=<Tabstyle_33 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_33@ebe6z1`}  {...this.props} tabid={tabid}/>;break;
            // 胶囊tab1
            case '34':tabtitle=<Tabstyle_34 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_34@hexe9y`}  {...this.props} tabid={tabid}/>;break;
            // 胶囊tab2
            case '35':tabtitle=<Tabstyle_35 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_35@8vfrwe`}  {...this.props} tabid={tabid}/>;break;
            // 方形tab1
            case '36':tabtitle=<Tabstyle_36 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_36@p85khn`}  {...this.props} tabid={tabid}/>;break;
            // 方形tab2
            case '37':tabtitle=<Tabstyle_37 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_37@zm3pek`}  {...this.props} tabid={tabid}/>;break;
            // 对话框1
            case '38':tabtitle=<Tabstyle_38 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_38@wdm53k`}  {...this.props} tabid={tabid}/>;break;
            // 对话框2
            case '39':tabtitle=<Tabstyle_39 ecId={`${this && this.props && this.props.ecId || ''}_Tabstyle_39@0fshwk`}  {...this.props} tabid={tabid}/>;break;

            default:tabtitle=<div></div>;
        }
        return tabtitle;
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/tabstyle/index.js